import React, { useState, useEffect } from "react";

export const Coming = () => {

  return (
    <div className="w-full h-full flex justify-center items-center">
        <img
          src="/coming.svg"
          alt="Coming soon"
          className="w-[60%] max-w-[400px]"
        />
    </div>
  );
};
